var _g, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResolution(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.11,
    height: 19.19,
    viewBox: "0 0 19.11 19.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICONOS_FLUJO",
    "data-name": "ICONOS FLUJO"
  }, /*#__PURE__*/React.createElement("g", {
    id: "resolution"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gavel"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.21,19a1.17,1.17,0,0,1-1.7.83l-1.76-1.09a1.17,1.17,0,0,1-.05-1.92c.06-.05.07-.11.13-.16.5-.81,1-1.56,1.44-2.37.06,0,.07-.17.08-.23a1.18,1.18,0,0,1,1.71-.89l1.76,1.09a1.2,1.2,0,0,1,.05,1.92,1.46,1.46,0,0,0-.26.32c.43.23.86.45,1.23.68,1.08.59,2.16,1.13,3.23,1.73a1.48,1.48,0,0,1,.85,1.5,1.51,1.51,0,0,1-2.38,1.15c-.89-.63-1.85-1.27-2.74-1.9-.48-.35-1-.64-1.43-1A.47.47,0,0,1,15.21,19Zm.64-1c.16.14.32.22.48.35L20,20.86a.68.68,0,0,0,.79.16.74.74,0,0,0,0-1.34c-.54-.3-1.13-.6-1.73-.91-.91-.46-1.77-1-2.69-1.43,0,0,0-.07-.1-.08C16.08,17.54,15.94,17.75,15.85,18Zm-3.14-1c.63.43,1.33.81,2,1.24.43-.64.8-1.35,1.23-2-.64-.43-1.34-.81-2-1.24C13.5,15.65,13.08,16.29,12.71,17Zm3.67-2c-.53-.35-1.12-.66-1.65-1a.39.39,0,0,0-.53.17c.8.45,1.54.95,2.29,1.39A.34.34,0,0,0,16.38,15Zm-4.16,3.14c.59.36,1.12.72,1.66,1a.39.39,0,0,0,.53-.17c-.75-.44-1.49-.94-2.24-1.38C12,17.85,12.06,18.08,12.22,18.16Z",
    transform: "translate(-2.98 -2.81)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.33
  })), /*#__PURE__*/React.createElement("g", {
    id: "_5",
    "data-name": 5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.34,6.58H17a.58.58,0,0,1,.59.59.57.57,0,0,1-.59.59H14.75a.6.6,0,0,1-.59-.67V4.32a.53.53,0,0,1,.59-.59.57.57,0,0,1,.59.59V6.58Z",
    transform: "translate(-2.98 -2.81)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.77,2.81a6.46,6.46,0,0,1,.8,0A5.92,5.92,0,0,1,16.69,4c1.5,1.24,1.65,3.27,1.77,4.86A11.65,11.65,0,0,1,18.41,11a.59.59,0,0,1-.55.66.57.57,0,0,1-.5-.67V9.27c0-3.86-1.18-5.21-4.46-5.21H8.53c-3.28,0-4.45,1.35-4.45,5.21v5.05c0,3.86,1.17,5.29,4.45,5.29H10c.25,0,.5.25.5.67s-.25.68-.5.68H8.53C4.66,21,3,19,3,14.4v-5C3,4.82,4.66,2.89,8.53,2.89,8.78,2.89,10.11,2.84,12.77,2.81Z",
    transform: "translate(-2.98 -2.81)",
    fill: "{props.color}"
  })), /*#__PURE__*/React.createElement("g", {
    id: "lineas"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.85,11.34H6.23c-.08,0-.17,0-.22,0a.7.7,0,0,1-.2-.39A.69.69,0,0,1,6,10.55c0-.05.13,0,.19,0h7.47c.14,0,.23.14.24.38s-.1.38-.25.41H9.85Z",
    transform: "translate(-2.98 -2.81)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 1.14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.56,9.22H6c-.31,0-.5-.16-.47-.41A.38.38,0,0,1,6,8.43h5.1c.32,0,.48.14.46.41s-.22.38-.46.38Z",
    transform: "translate(-2.98 -2.81)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.57,13.55H5.76s-.09,0-.11,0a.89.89,0,0,1-.1-.38,1.12,1.12,0,0,1,.1-.38s.06,0,.1,0H9.48c.07,0,.12.14.12.38s0,.38-.12.41a.27.27,0,0,1-.09,0Z",
    transform: "translate(-2.98 -2.81)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.81
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.46,22",
    transform: "translate(-2.98 -2.81)",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.88,17.54",
    transform: "translate(-2.98 -2.81)",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 1.1,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResolution);
export default __webpack_public_path__ + "static/media/resolution.275498264d307170457582ddbe4b2453.svg";
export { ForwardRef as ReactComponent };